<template>
  <div>
    <div class="modal is-modal-large" v-if="video" :class="{'is-active': active}">
      <div class="modal-background" @click.prevent.stop="close"></div>
      <div class="modal-card">
        <header class="modal-card-head">
          <p class="modal-card-title">
            <span class="picto"><span class="has-text-grey is-border"><i class="fas fa-video"></i></span></span>
            Vidéo
          </p>
          <button @click.prevent.stop="close" class="delete" aria-label="close"></button>
        </header>
        <section class="modal-card-body is-padding-top-large is-padding-bottom-large">
          <video-external
            class="is-margin-top-large is-margin-bottom-large"
            :video="video"
          >
          </video-external>
        </section>
      </div>
    </div>
  </div>
</template>

<script>
  import VideoExternal from '../utils/VideoExternal'

  export default {
    name: 'ModalVideo',
    components: {
      VideoExternal
    },
    data () {
      return {}
    },
    props: {
      active: {
        type: Boolean,
        required: true
      },
      selectedDocument: {
        type: Object,
        required: true
      }
    },
    computed: {
      video () {
        return this.selectedDocument
      }
    },
    methods: {
      close () {
        this.$emit('close')
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/modal/VideoPreview.vue